import { render, staticRenderFns } from "./EnrollmentCard.vue?vue&type=template&id=2b975f74&scoped=true"
import script from "./EnrollmentCard.vue?vue&type=script&lang=js"
export * from "./EnrollmentCard.vue?vue&type=script&lang=js"
import style0 from "./EnrollmentCard.vue?vue&type=style&index=0&id=2b975f74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b975f74",
  null
  
)

export default component.exports